export default ({ width = "18", height = "14", fill = "#111928" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.25 0.75C0.25 0.40625 0.53125 0.125 0.875 0.125H17.125C17.4688 0.125 17.75 0.40625 17.75 0.75C17.75 1.09375 17.4688 1.375 17.125 1.375H0.875C0.53125 1.375 0.25 1.09375 0.25 0.75ZM0.25 7C0.25 6.65625 0.53125 6.375 0.875 6.375H17.125C17.4688 6.375 17.75 6.65625 17.75 7C17.75 7.34375 17.4688 7.625 17.125 7.625H0.875C0.53125 7.625 0.25 7.34375 0.25 7ZM17.75 13.25C17.75 13.5938 17.4688 13.875 17.125 13.875H0.875C0.53125 13.875 0.25 13.5938 0.25 13.25C0.25 12.9062 0.53125 12.625 0.875 12.625H17.125C17.4688 12.625 17.75 12.9062 17.75 13.25Z"
      fill={fill}
    />
  </svg>
);
